var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "nav",
      {
        staticClass: "navbar navbar-default navbar-fixed-top",
        attrs: { role: "navigation", id: "shrink" }
      },
      [
        _c(
          "div",
          {
            staticClass: "container contain-top",
            attrs: { id: "upper-nav-shrink" }
          },
          [
            _c(
              "div",
              { staticClass: "contain-top-lower" },
              [
                _c(
                  "div",
                  { staticClass: "navbar-header" },
                  [
                    _c(
                      "b-navbar-toggle",
                      {
                        staticClass: "nav float-right d-lg-none mob-navbar",
                        staticStyle: {
                          border: "0",
                          outline: "none",
                          display: "block"
                        },
                        attrs: {
                          id: "openMenu",
                          target: "navbar-toggle-collapse-mob"
                        },
                        on: {
                          click: function($event) {
                            return _vm.showCloseMenu()
                          }
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-bars",
                          attrs: { "aria-hidden": "true" }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-navbar-toggle",
                      {
                        staticClass: "nav float-right d-lg-none mob-navbar",
                        staticStyle: {
                          border: "0",
                          outline: "none",
                          display: "none"
                        },
                        attrs: {
                          id: "closeMenu",
                          target: "navbar-toggle-collapse-mob"
                        },
                        on: {
                          click: function($event) {
                            return _vm.showOpenMenu()
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "hamburger-box" }, [
                          _c("span", { staticClass: "hamburger-inner" })
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "navbar-brand logo-main",
                        attrs: { href: _vm.mmSiteUrl }
                      },
                      [
                        _c("img", {
                          attrs: {
                            src:
                              _vm.mmSiteUrl +
                              "hubfs/Mentor_Mentee_May2025/Images/MM-logo.png",
                            alt: "Mentor Mentee"
                          }
                        })
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-collapse",
                  {
                    staticClass: "d-lg-none kl-navbar__menu ",
                    attrs: { id: "navbar-toggle-collapse-mob" }
                  },
                  [
                    _c(
                      "b-navbar-nav",
                      {
                        staticClass: " nav navbar-nav navbar-right",
                        staticStyle: { width: "95%", margin: "0" }
                      },
                      [
                        _c(
                          "b-nav-item-dropdown",
                          { attrs: { text: "Product", right: "" } },
                          [
                            _c(
                              "b-nav-item",
                              {
                                staticClass:
                                  "kl-navbar__item kl-navbar__parent",
                                attrs: { href: _vm.mmSiteUrl + "product" }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "text-center btn-mobile-cta" },
                                  [
                                    _vm._v(
                                      "\n                        Product\n                      "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-nav-item",
                              {
                                staticClass: "btn btn-danger btn-login",
                                attrs: { href: _vm.mmSiteUrl + "faq" }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "text-center btn-mobile-cta" },
                                  [
                                    _vm._v(
                                      "\n                        FAQS\n                      "
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-nav-item-dropdown",
                          { attrs: { text: "About Us", right: "" } },
                          [
                            _c(
                              "b-nav-item",
                              {
                                staticClass: "btn btn-danger btn-login",
                                attrs: { href: _vm.mmSiteUrl + "about" }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "text-center btn-mobile-cta" },
                                  [
                                    _vm._v(
                                      "\n                        Meet the Team\n                      "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-nav-item",
                              {
                                staticClass: "btn btn-danger btn-login",
                                attrs: { href: _vm.mmSiteUrl + "contact-us" }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "text-center btn-mobile-cta" },
                                  [
                                    _vm._v(
                                      "\n                        Contact Us\n                      "
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-nav-item",
                          {
                            staticClass: "btn btn-danger btn-login",
                            attrs: { href: _vm.mmSiteUrl + "resource-center" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "btn-mobile-cta1",
                                staticStyle: {
                                  "padding-top": "14px !important"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                        Resource Center\n                      "
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-nav-item",
                          {
                            staticClass: "btn btn-danger btn-login",
                            attrs: { href: _vm.mentoringUrl + "mmlogin" }
                          },
                          [
                            _c("div", { staticClass: "btn-mobile-cta1" }, [
                              _vm._v(
                                "\n                        Log In\n                      "
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-nav-item",
                          {
                            staticClass: "text-center contact-btn",
                            attrs: { href: _vm.mmSiteUrl + "contact-us" }
                          },
                          [
                            _c("div", { staticClass: "contactus-btn" }, [
                              _vm._v(
                                "\n                        Contact Us\n                      "
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "collapse navbar-collapse",
                    attrs: { id: "bs-example-navbar-collapse-1" }
                  },
                  [
                    _c(
                      "div",
                      { attrs: { id: "dnav" } },
                      [
                        _c(
                          "ul",
                          {
                            staticClass:
                              "nav navbar-nav navbar-right d-none d-lg-block"
                          },
                          [
                            _c(
                              "li",
                              {
                                staticClass:
                                  "menu-item menu-item-type-post_type menu-item-object-page mm-login contactus-btn",
                                attrs: { id: "menu-item-764" }
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticStyle: { color: "#FFF !important" },
                                    attrs: {
                                      href: _vm.mmSiteUrl + "contact-us"
                                    }
                                  },
                                  [_vm._v("Contact Us")]
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "ul",
                          {
                            staticClass:
                              "nav navbar-nav navbar-right d-none d-lg-block",
                            attrs: { id: "menu-main-menu" }
                          },
                          [
                            _c(
                              "li",
                              {
                                staticClass:
                                  "menu-item menu-item-type-post_type menu-item-object-page menu-item-764 ",
                                attrs: { id: "menu-item-764" }
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.mentoringUrl + "mmlogin"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "Log\n                              In"
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "ul",
                          {
                            staticClass:
                              "nav navbar-nav navbar-right d-none d-lg-block",
                            attrs: { id: "menu-main-menu" }
                          },
                          [
                            _c(
                              "li",
                              {
                                staticClass:
                                  "menu-item menu-item-type-post_type menu-item-object-page menu-item-764 ",
                                attrs: { id: "menu-item-764" }
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href:
                                        _vm.mmSiteUrl +
                                        "technical-mentoring-news"
                                    }
                                  },
                                  [_vm._v("Resource Center")]
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "ul",
                          {
                            staticClass:
                              "nav navbar-nav navbar-right d-none d-lg-block",
                            attrs: { id: "menu-main-menu" }
                          },
                          [
                            _c("li", { staticClass: "dropdown-3" }, [
                              _c("div", { staticClass: "dropdown" }, [
                                _vm._v(
                                  "About Us\n\n                            "
                                ),
                                _c("div", { staticClass: "dropdown-content" }, [
                                  _c(
                                    "div",
                                    { staticClass: "kl-navbar-submenu" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: _vm.mmSiteUrl + "about"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                  Meet the Team\n                              "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: _vm.mmSiteUrl + "contact-us"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                  Contact Us\n                              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "ul",
                          {
                            staticClass:
                              "nav navbar-nav navbar-right d-none d-lg-block",
                            attrs: { id: "menu-main-menu" }
                          },
                          [
                            _c("li", { staticClass: "dropdown-3" }, [
                              _c("div", { staticClass: "dropdown" }, [
                                _vm._v(
                                  "Product\n\n                            "
                                ),
                                _c("div", { staticClass: "dropdown-content" }, [
                                  _c(
                                    "div",
                                    { staticClass: "kl-navbar-submenu" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: _vm.mmSiteUrl + "product"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                  Product\n                              "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          attrs: { href: _vm.mmSiteUrl + "faq" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                  FAQs\n                              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-collapse",
                          { attrs: { id: "navbar-toggle-collapse-about" } },
                          [
                            _c(
                              "b-navbar-nav",
                              { staticClass: "nav dropdown-menu" },
                              [
                                _c(
                                  "b-nav-item",
                                  { attrs: { href: _vm.mmSiteUrl } },
                                  [
                                    _c("div", { staticClass: "text-center " }, [
                                      _vm._v(
                                        "\n                        Home\n                      "
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-nav-item",
                                  {
                                    staticClass: "btn btn-danger btn-login",
                                    attrs: { href: _vm.mmSiteUrl + "about" }
                                  },
                                  [
                                    _c("div", { staticClass: "text-center" }, [
                                      _vm._v(
                                        "\n                        About Us\n                      "
                                      )
                                    ])
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2fc6202c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fc6202c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mm_header.vue
// module id = null
// module chunks = 